import React from 'react';
import { NavLink } from 'react-router-dom';
import { NavItem } from 'reactstrap';

import NavItemMore from './NavItemMore';

const quotesOrOpportunities = (match, location) => {
  return (
    location.pathname.match(/^\/opportunities/) ||
    location.pathname.match(/^\/quotes/)
  );
};

function SalesBackOfficeNavigation() {
  return (
    <>
      <NavItem>
        <NavLink
          className="nav-link"
          to="/opportunities"
          isActive={quotesOrOpportunities}
        >
          Opportunities
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink className="nav-link" to="/campaigns">
          Campaigns
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink className="nav-link" to="/benchmarks">
          Benchmarks
        </NavLink>
      </NavItem>
      {/*       <NavItem>
        <NavLink className="nav-link" to="/sku-search">
          SKUs
        </NavLink>
      </NavItem> */}
      <NavItemMore
        items={[
          { text: 'Brands', href: '/brands' },
          { text: 'Contacts', href: '/contacts' },
          { text: 'Invoices', href: '/invoices' },
          { text: 'Users', href: '/users' },
        ]}
      />
    </>
  );
}

export default SalesBackOfficeNavigation;
